<template>
    <div class="modal-backdrop" @click="$emit('close')">
    <div class="modal" @click.stop="">
      <h1>Наши контакты:</h1>
      <div class="contacts">
        <div class="phones">
          <h3>моб. и WhatsApp:</h3><a href="tel:89035498889"><h3>8-903-549-88-89</h3></a>
          <h3>офис:</h3>  <a href="tel:84957452209"><h3>8-495-745-22-09</h3></a>
        </div>
        <div class="email">
          <h3>Эл.почта:</h3><a href="mailto:7452209@mail.ru"><h3>7452209@mail.ru</h3></a>
        </div>
        <div class="location">
          <h3>Наш адрес: <br> ул.Горшина, 9, к.1, Химки, Московская область.</h3>
          <a href="https://yandex.ru/profile/1145360414?lr=216" target="_blank"> Перейти к карте </a>
        </div>
      </div>
    </div>
    </div>
</template>

<script>
  export default {
    emits: ['close']
  }
</script>

<style scoped>

h1, h3 {
  text-align: center;
  font-family: "Poppins", sans-serif !important;
}

.contacts {
  flex-direction: column;
  display: flex;
  text-align: center;
  justify-content: center;
}

.phones, .email {
  text-align: center;
}

@media (max-width: 768px) {
  .location h3 {
    font-size: 16px;
  }
}

@media (max-height: 600px) {
  h3 {
    font-size: 16px;
  }

  .contacts {
    flex-direction: row;
    margin: 20px;
  }
}

</style>